// extracted by mini-css-extract-plugin
export var root = "role-list-module--root--fnFFq";
export var headline = "role-list-module--headline--EqxWV typography-module--base--FphVn";
export var list = "role-list-module--list--OFS5L";
export var listItem = "role-list-module--listItem--Y+X92";
export var avatar = "role-list-module--avatar--Exx3K";